import React, { useContext, useEffect, useRef, useState } from "react";
import "../css/layout.css";
import css from "../Modulecss/Home.module.css";
import axios from "axios";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import { useDispatch } from "react-redux";
import BetCard from "./BetCard";
import RunningCard from "./RunningCard";
import Header from "../Components/Header";
import io from "../Components/socket";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import guidebutton from "../../assets/images/guidebutton.png";
import socket from "../Components/socket";
import acceptSound from "./accept.mp3";
import findGif from "../css/loading_old.gif";
import playSound from "../uiComponents/accept.mp3";
import { MdOutlineDelete } from "react-icons/md";
import { FiRefreshCcw } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";

export default function Homepage({ rungame, homePlay, users }) {
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const history = useHistory();
  let userID = useRef();
  const isMounted = useRef(true);
  let str;

  const [user, setUser] = useState();
  const [create, setCreated] = useState([]);
  const [challangeReqRun, setChallangeReqRun] = useState(false);

  const [game_amount, setGame_amt] = useState();

  const [gameData, setGameData] = useState({});

  const [submitProcess, setProcess] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const userId = localStorage.getItem("userId");
  const access_token = localStorage.getItem("token");
  const [disable, setDisable] = React.useState(challangeReqRun);
  const [disable_play, setDisable_play] = React.useState(false);
  const [GameList, setGameList] = useState(homePlay);
  const [runningsGames, setRunningsGames] = useState([]);

  const req_chall_fun = (allgameId) => {
    getPost(allgameId);
  };

  const disablebtn = (id) => {
    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 10000);
    //  sendMessage()
  };

  const disable_play_btn = () => {
    setDisable_play(true);
    setTimeout(() => {
      setDisable_play(false);
    }, 3000);
    // status_fun()
  };

  /// user details end

  const [game_type, setGame_type] = useState(
    useLocation().pathname.split("/")[2],
  );
  const [game_type2, setGame_type2] = useState(
    useLocation().pathname.split("/")[3],
  );
  const [Game_Ammount, setGame_Ammount] = useState("");

  const ChallengeCreate = async (e) => {
    setIsloading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (game_type == "ludoClassicManual") {
      if (Game_Ammount >= 50 && Game_Ammount <= 50000) {
        try {
          const res = await apiRequest(
            `challange/create`,
            "POST",
            { Game_Ammount, Game_type: game_type },
            headers,
          );
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({
              title: "You have already enrolled",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({
              title: "You can set maximum 2 battle.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({
              title: "Insufficient balance",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (
            res.data.msg ===
            "Game amount should be Greater then 50 and less then 50000"
          ) {
            setIsloading(false);
            Swal.fire({
              title:
                "Game amount should be Greater then 50 and less then 50000",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({
              title: "Set Battle in denomination of 50",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({
              title: "Technical Issue, Try after an hour!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            setIsloading(false);
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("token");
            window.location.reload();
            setTimeout(() => {
              //  history.push("/login")
            }, 500);
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
          console.log(e);
        }
      } else {
        setIsloading(false);
        Swal.fire({
          title: "Please Amount should be greater 50 and less 50000!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else if (game_type == "ludoClassicRich") {
      if (Game_Ammount >= 550 && Game_Ammount <= 200000) {
        try {
          const res = await apiRequest(
            `challange/create`,
            "POST",
            { Game_Ammount, Game_type: game_type },
            headers,
          );
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({
              title: "You have already enrolled",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({
              title: "You can set maximum 2 battle.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({
              title: "Insufficient balance",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (
            res.data.msg ===
            "Game amount should be Greater then 50 and less then 50000"
          ) {
            setIsloading(false);
            Swal.fire({
              title:
                "Game amount should be Greater then 50 and less then 50000",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({
              title: "Set Battle in denomination of 50",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({
              title: "Technical Issue, Try after an hour!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            setIsloading(false);
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("token");
            window.location.reload();
            setTimeout(() => {
              //  history.push("/login")
            }, 500);
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
          console.log(e);
        }
      } else {
        setIsloading(false);
        Swal.fire({
          title: "Please Amount should be greater 550 and less 200000!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else {
      try {
        const res = await apiRequest(
          `challange/create`,
          "POST",
          { Game_Ammount, Game_type: game_type },
          headers,
        );

        setGame_amt(res?.data?.data?.Game_Ammount);

        if (res.data.status == false) {
          setIsloading(false);
          Swal.fire({
            title: res.data.msg,
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "you have already enrolled") {
          setIsloading(false);
          Swal.fire({
            title: "You have already enrolled",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "You can set maximum 2 battle.") {
          setIsloading(false);
          Swal.fire({
            title: "You can set maximum 2 battle.",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Insufficient balance") {
          setIsloading(false);
          Swal.fire({
            title: "Insufficient balance",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (
          res.data.msg ===
          "Game amount should be Greater then 50 and less then 50000"
        ) {
          setIsloading(false);
          Swal.fire({
            title: "Game amount should be Greater then 50 and less then 50000",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Set Battle in denomination of 50") {
          setIsloading(false);
          Swal.fire({
            title: "Set Battle in denomination of 50",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Technical Issue, Try after an hour!") {
          setIsloading(false);
          Swal.fire({
            title: "Technical Issue, Try after an hour!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else {
          setIsloading(false);
        }
      } catch (e) {
        setIsloading(false);
        if (e?.response?.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
          setTimeout(() => {
            //  history.push("/login")
          }, 500);
        }
        if (e?.response?.status == 400 || e?.response?.status == 429) {
          Swal.fire({
            title: "Please refresh!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
        console.log(e);
        // });
      }
    }
  };

  //open bat

  const [MyopenBattle, setMyOpenBattle] = useState([]);
  const [OtheropenBattle, setOtherMyOpenBattle] = useState([]);
  const [MyrunningBattle, setMyRunningBattle] = useState([]);
  const [OtherrunningBattle, setOtherRunningBattle] = useState([]);

  useEffect(() => {
    socket.emit("getgamelist", userId);
    socket.on("setGamelist", (data) => {
      setGameList(data);
    });
  }, []);

  useEffect(() => {
    io.on("gameCreate", (data) => {
      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });
    io.on("deletebat", (data) => {
      // Log the _id values in the MyopenBattle array
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item._id !== data,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item._id !== data,
        );
        return updatedOtheropenBattle;
      });
    });

    io.on("gameUpdate", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });
      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });

    io.on("startAccepted", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });

      if (data.Status === "running" && data?.Created_by?._id === userId) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      } else if (
        data.Status === "running" &&
        data?.Accepetd_By?._id === userId
      ) {
        if (!MyopenBattle?.some((item) => item?._id === data?._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtherrunningBattle?.some((item) => item?._id === data?._id)) {
          setOtherRunningBattle((OtherrunningBattle) => [
            data,
            ...OtherrunningBattle,
          ]);
        }
      }
    });

    io.on("acceptor_seen_game", (data) => {
      // debugger
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });

      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
    io.on("challangeAccept", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item._id !== data._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle?.filter(
          (item) => item._id !== data._id,
        );
        return updatedOtheropenBattle;
      });

      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
  }, [io]);

  function winnAmount(gameAmount) {
    let profit = null;
    // {console.log(addCaseSetting?.commissionRange2)}
    if (gameAmount >= 50 && gameAmount <= 250)
      profit = (gameAmount * addCaseSetting?.commissionRange1) / 100;
    else if (gameAmount > 250 && gameAmount <= 500)
      profit = addCaseSetting?.commissionRange2;
    else if (gameAmount > 500)
      profit = (gameAmount * addCaseSetting?.commissionRange3) / 100;
    return gameAmount - profit;
  }

  useEffect(() => {
    // walletUpdate();
    let owenedCreated = [];
    let remainingGame = [];

    GameList?.openBattle?.forEach(function (ele) {
      if (ele)
        if (
          (ele?.Created_by?._id == userId || ele?.Accepetd_By?._id == userId) &&
          (ele?.Status == "new" || ele?.Status == "requested")
        ) {
          owenedCreated.push(ele);
        } else if (ele?.Status == "new") {
          remainingGame.push(ele);
        } else if (
          ele?.Status == "running" &&
          ele?.Accepetd_By?._id == userId &&
          ele?.Acceptor_seen === false
        ) {
          owenedCreated.push(ele);
        }
    });
    setMyOpenBattle(owenedCreated);
    setOtherMyOpenBattle(remainingGame);
    let owenedRunning = [];
    let remainingRunning = [];
    GameList?.runningBattle?.forEach(function (ele) {
      if (ele.Created_by && ele.Accepetd_By)
        if (ele.Created_by?._id == userId || ele.Accepetd_By?._id == userId) {
          owenedRunning.push(ele);
        } else {
          remainingRunning.push(ele);
        }
    });
    setMyRunningBattle(owenedRunning);

    setOtherRunningBattle(remainingRunning);
    // walletUpdate();
  }, [GameList]);

  useEffect(() => {
    io.on("resultUpdateReq1", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });

      if (data.Status === "cancelled" || data.Status === "completed") {
        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedowenedRunning;
        });
        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedrunningGames;
        });
      } else {
        // Check if the user's ID matches Created_by or Accepted_By
        const isUserOwned =
          data?.Created_by?._id === userId || data?.Accepetd_By?._id === userId;

        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          if (isUserOwned) {
            updatedowenedRunning.push(data);
          }
          return updatedowenedRunning;
        });

        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          if (!isUserOwned) {
            updatedrunningGames.push(data);
          }
          return updatedrunningGames;
        });
      }
    });
  }, [io, userId]);

  // useEffect(() => {
  //   io.on("resultUpdateReq1", (data) => {
  //     setMyOpenBattle((MyopenBattle) => {
  //       const updatedMyOpenBattle = MyopenBattle?.filter(
  //         (item) => item?._id !== data?._id
  //       );
  //       return updatedMyOpenBattle;
  //     });
  //     let owenedRunning = [];
  //     let remainingRunning = [];
  //     if (data.Status == "cancelled" || data.Status == "completed") {
  //       setMyRunningBattle((MyrunningBattle) => {
  //         const updatedowenedRunning = MyrunningBattle?.filter(
  //           (item) => item?._id !== data?._id
  //         );
  //         return updatedowenedRunning;
  //       });
  //       setOtherRunningBattle((OtherrunningBattle) => {
  //         const updatedrunningGames = OtherrunningBattle?.filter(
  //           (item) => item?._id !== data?._id
  //         );
  //         return updatedrunningGames;
  //       });
  //     } else {
  //       if (data?.Created_by && data?.Accepetd_By)
  //         if (
  //           data?.Created_by?._id == userId ||
  //           data?.Accepetd_By?._id == userId
  //         ) {
  //           owenedRunning.push(data);
  //         } else {
  //           remainingRunning.push(data);
  //         }
  //       // });
  //       setMyRunningBattle(owenedRunning);
  //       setOtherRunningBattle(remainingRunning);
  //     }
  //   });
  // }, [io]);

  useEffect(() => {
    let access_token = localStorage.getItem("token");
    access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      setTimeout(() => {}, 500);
    }

    return () => {
      // role();
    };
  }, []);

  const RunningGames = async () => {
    const access_tokena = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/running/all`,
        "GET",
        null,
        headers,
      );
      setRunningsGames(res?.data);
    } catch (e) {
      console.log("errror", e);
    }

    // .then((res) => {

    // })
    // .catch((e) => {
    //   console.log("errror", e);
    // });
  };

  //accept Challange

  const AcceptChallang = async (id) => {
    if (str == 1) {
      Swal.fire({
        title: "Other request in process",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
    str = 1;
    const access_token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/accept/${id}`,
        "PUT",
        { Accepetd_By: headers, Acceptor_by_Creator_at: Date.now() },
        headers,
      );
      setGameData({
        accept_by: res.data.Accepetd_By,
        created_by: res.data.Created_by,
      });

      str = 0;
      if (res.data.status === false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "you have already enrolled") {
        Swal.fire({
          title: "You have already enrolled",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "Insufficient balance") {
        Swal.fire({
          title: "Insufficient balance",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "Game already start with other player") {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {}, 500);
      }
      if (e.response.status == 400) {
        Swal.fire({
          title: e.response.data,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  //reject Game
  const RejectGame = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/reject/${id}`,
        "PUT",
        { Accepetd_By: null, Status: "new", Acceptor_by_Creator_at: null },
        headers,
      );
      if (res) {
        // io.emit("gameRejected");
      }
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  //delete

  const deleteChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/delete/${_id}`,
        "DELETE",
        null,
        headers,
      );
      if (res.data.status == false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      if (e?.response?.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  ///challange/running/update/

  const updateChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/running/update/${_id}`,
        "PUT",
        { Acceptor_seen: true },
        headers,
      );
      if (res) {
        localStorage.setItem("timeOver", "timeStart");
        // io.emit("game_seen");
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      console.log(e);
    }
  };

  const getPost = async (Id) => {
    if (
      game_type === "Ludo Classics" ||
      game_type === "Ludo 1 Goti" ||
      game_type === "Ludo Ulta" ||
      game_type === "Prime Ludo" ||
      game_type === "Ludo Host"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);

        const access_token = localStorage.getItem("token");

        const headers = {
          authorization: `Bearer ${access_token}`,
        };

        try {
          const res = await apiRequest(
            `challange/requested/running/${game_type}/` + Id,
            "PATCH",
            null,
            headers,
          );
          setProcess(true);
          setChallangeReqRun(false);
          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame1/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      }
    } else if (
      game_type === "LudoSnake" ||
      game_type === "LudoPopular" ||
      game_type === "ludoClassicManual" ||
      game_type === "ludoClassicRich"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);

        const access_token = localStorage.getItem("token");

        const headers = {
          authorization: `Bearer ${access_token}`,
        };

        try {
          const res = await apiRequest(
            "challange/requested/running/" + Id,
            "PATCH",
            {},
            headers,
          );
          setProcess(true);
          setChallangeReqRun(false);

          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame1/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      }
    }
  };

  const handleButtonClick = (gameType) => {
    setGame_type(gameType);
  };
  // Socket for GameModeChange list

  const GameModeChange = () => {
    socket.on("setGamelist", (modeData) => {
      setGameList(modeData);
    });
  };
  useEffect(() => {
    RunningGames();
  }, []);

  // language
  const translations = {
    hi: {
      gameadd: "गेम बनाये !",
      gameset: "लगाये",
      openGame: "खुला गेम ",
      challange: "चुनोती देने वाला  ",
      entry: "प्रवेश शुल्क",
      prize: "इनाम",
      play: "खेले ",
      running: "चल रहे गेम ",
      start: "चालू",
      cancel: "रद्द करें",
    },
    en: {
      gameadd: "Create a Battle!",
      gameset: "Set",
      openGame: "Open Battles",
      challange: "Challange From  ",
      entry: "Entry Fee ",
      prize: "winning Prize  ",
      play: "Play",
      running: "Running Battles",
      start: "Start",
      cancel: "Decline",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  // change theme
  // const theme1 = localStorage.getItem("theme");
  // let theme = "";
  // if (theme1 == "dark") {
  //   theme = "light";
  // } else {
  //   theme = "dark";
  // }
  const theme = localStorage.getItem("theme");
  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "black",
    color: theme === "light" ? "black" : "#fff",
  };
  const styles1 = {
    backgroundColor: theme === "light" ? "#000" : "green",
    color: theme === "light" ? "black" : "#fff",
  };
  const styles3 = {
    backgroundColor: theme === "light" ? "rgb(38, 53, 93)" : "#27241b",
    color: theme === "light" ? "#fff" : "#fff",
  };

  const backgroundColor = theme === "light" ? "#fff" : "#333 !important";

  return (
    <>
      {/* <Header user={users} /> */}
      <div className="leftContainer mb_space " style={styles}>
        <div className="Orher_page_main_section" style={styles}>
          {/* {game_type === "ludoClassicManual" ||
          game_type === "ludoClassicRich" ? (
            <div className="modeButton">
              <Link
                to="ludoClassicManual"
                className={`game_tabs_btn mb-3  ${
                  game_type === "ludoClassicManual" ? "active" : ""
                }`}
                onClick={() => {
                  handleButtonClick("ludoClassicManual");
                  GameModeChange();
                }}
              >
                Lite Mode (50 - 500)
              </Link>
              <Link
                to="ludoClassicRich"
                className={`game_tabs_btn mb-3 ml-2 ${
                  game_type === "ludoClassicRich" ? "active" : ""
                }`}
                onClick={() => {
                  handleButtonClick("ludoClassicRich");
                  GameModeChange();
                }}
              >
                 Rich Mode (550 - 200000)
              </Link>
            </div>
          ) : (
            ""
          )} */}

          {/* <div style={styles3}>
            <div className="alrt_msg_div" styles={styles3}>
              {game_type === "LudoSnake" ? (
                <h5 className="" styles={styles3}>
                  {JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                    ? ""
                    : JSON.parse(localStorage.getItem("sitSetting"))
                      ?.ludoClassicManualMsg}
                </h5>
              ) : (
                <h5 className="" styles={styles3}>
                  {JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                    ? ""
                    : JSON.parse(localStorage.getItem("sitSetting"))
                      ?.ludoClassicAutoMsg}
                </h5>
              )}
            </div>
          </div> */}

          {(() => {
            const sitSettingRaw = localStorage.getItem("sitSetting");

            if (!sitSettingRaw || sitSettingRaw === "undefined") return null;

            const sitSetting = JSON.parse(sitSettingRaw);
            const manualMsg = sitSetting?.ludoClassicManualMsg;
            const autoMsg = sitSetting?.ludoClassicAutoMsg;

            const showMessage = game_type === "LudoSnake" ? manualMsg : autoMsg;

            if (!showMessage) return null;

            return (
              <div style={{}}>
                <div className="alrt_msg_div">
                  <h5 className="">{showMessage}</h5>
                </div>
              </div>
            );
          })()}

          <div>
            {/* Create a Battle */}

            {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
              ""
            ) : JSON.parse(localStorage.getItem("sitSetting"))?.gameSearch ==
              true ? (
              <>
                <div className="battel-bx position-relative">
                  {/* <span className="other_page_small_headings text-dark">
                    {translations[language].gameadd}
                  </span> */}
                  <span
                    className={`${css.gamesSectionHeadline} info text-uppercase position-absolute  font-weight-bold rounded px-1 mt-0 mb-0 text-white `}
                    style={{ right: "11px", top: "-7px" }}
                  >
                    Rules
                    <NavLink to="/Rules">
                      <img
                        className="ml-2"
                        src={
                          process.env.PUBLIC_URL + "/images/Homepage/info.png"
                        }
                        alt=""
                        width="14px"
                      />
                    </NavLink>
                  </span>

                  <div className="user_reder_code_box mt-2">
                    {addCaseSetting.gameSearch && game_type2 != "new" ? (
                      <input
                        className="commaon_input_box home"
                        type="tel"
                        placeholder="Enter amount"
                        value={Game_Ammount}
                        onChange={(e) => setGame_Ammount(e.target.value)}
                      />
                    ) : null}

                    <div className="set  check_btn">
                      {" "}
                      {!isLoading ? (
                        <>
                          {addCaseSetting.gameSearch && game_type2 != "new" ? (
                            <button
                              className="sasamll_btn_game glow-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                setGame_Ammount("");

                                ChallengeCreate();
                              }}
                            >
                              {translations[language].gameset}
                            </button>
                          ) : null}
                        </>
                      ) : (
                        <button
                          className={`sasamll_btn_game glow-btn `}
                          disabled
                        >
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          Loading...
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="py-3">
              <div className="battle-cards">
                 <span
                  className={`battle-lefts`}
                >
                <img
                  src={
                    process.env.PUBLIC_URL + "/images/Battle soft colour.gif"
                  }
                  alt=""
                  width="30px"
                /></span>
                <span
                  className={`mx-2 ${css.gamesSectionTitle} battle-titles`}
                >
                  {translations[language].openGame}
                </span>
                <div class="battle-arrow">
                      ➜
                  </div>
                
                </div>

              {MyopenBattle &&
                MyopenBattle.filter(
                  (allgame) => allgame.Game_type === game_type,
                ).map((allgame, index) => (
                  <div className="battle-neon-mini">
                    <span className={`battle-leftsimg`} >
                <img src={process.env.PUBLIC_URL + "/game.png" }  alt="" width="150px" /></span>
                      {/* Left Side */}
                      <div className="neon-left">
                        <div className="neon-user">
                          <span className="live-ping"></span>
                          <div>
                            <h6>
                              {allgame.Created_by?.Name.length > 5
                                ? `${allgame.Created_by?.Name.slice(0, 5)}...`
                                : allgame.Created_by?.Name}
                            </h6>
                            <small>ID #{allgame?._id?.slice(-5)}</small>
                          </div>
                          
                        </div>
                        <div className="neon-amount-box">
                          <span>{translations[language].entry}</span>
                          <h6>₹{allgame?.Game_Ammount}</h6>
                        </div>
                      </div>
                      {/* Center */}
                      <div className="neon-middle">
                          <span>{translations[language].prize}</span>
                          <h3>
                            ₹
                            {allgame?.Game_Ammount +
                              winnAmount(allgame?.Game_Ammount)}
                          </h3>
                        </div>
                        {/* Right */}
                        <div className="neon-right">
                          {userId !== allgame?.Created_by?._id &&
                            allgame?.Status === "new" && (
                              <button
                                className="action-neon play"
                                onClick={() => {
                                  disable_play_btn();
                                  AcceptChallang(allgame?._id);
                                }}
                              >
                                PLAY
                              </button>
                            )}
 
                              {userId !== allgame?.Created_by?._id &&
                                allgame?.Status == "requested" && (
                                  <div className="action-group">
                                    <span className="action-neon start">
                                      Requests
                                    </span>
                                     <button
                                  className="action-neon cancel"
                                  onClick={() => RejectGame(allgame?._id)}
                                >
                                  ✕
                                </button>
                                  </div>
                                )}
                              {/* CASE 4: Delete & Loader (For Creator when game is new) */}
                                {userId == allgame?.Created_by?._id &&
                                  allgame?.Status == "new" && (
                                    <div className="action-group">
                                      <img
                                        src="/images/LandingPage_img/loader1.gif"
                                        className="mini-loader-gif"
                                        alt="waiting"
                                      />
                                      <button
                                        className="action-neon delete"
                                        onClick={() => deleteChallenge(allgame?._id)}
                                      >
                                        <MdOutlineDelete size={20} />
                                      </button>
                                    </div>
                                  )}
        
                                {/* CASE 5: Running Game Start (For Opponent when running) */}
                                {userId !== allgame?.Created_by?._id &&
                                  allgame?.Status == "running" && (
                                    <div className="action-group">
                                      <audio src={playSound} autoPlay></audio>
                                      <button
                                        className="action-neon start"
                                        onClick={() => {
                                          disablebtn();
                                          updateChallenge(allgame?._id);
                                          history.push(`/viewgame1/${allgame?._id}`, {
                                            prevPath: window.location.pathname,
                                          });
                                        }}
                                      >
                                        {translations[language].start}
                                      </button>
                                    </div>
                                  )}
                          {userId === allgame?.Created_by?._id &&
                            allgame?.Status === "requested" && (
                              <div className="action-group">
                                <button
                                  className="action-neon start"
                                  onClick={() => {
                                    disablebtn(allgame?._id);
                                    req_chall_fun(allgame?._id);
                                  }}
                                >
                                  START
                                </button>

                                <button
                                  className="action-neon cancel"
                                  onClick={() => RejectGame(allgame?._id)}
                                >
                                  ✕
                                </button>
                              </div>
                            )}
                    </div>
                  </div>
                ))}

              {OtheropenBattle &&
                OtheropenBattle?.filter(
                  (allgame) => allgame.Game_type === game_type,
                ).map((allgame, index) => (
                  <div className="battle-neon-mini">
                      <span className={`battle-leftsimg`} >
                <img src={process.env.PUBLIC_URL + "/game.png" }  alt="" width="150px" /></span>
                    {/* Left Side */}
                    <div className="neon-left">

                      <div className="neon-user">
                        <span className="live-ping"></span>

                        <div>
                          <h6>
                            {allgame.Created_by?.Name.length > 5
                              ? `${allgame.Created_by?.Name.slice(0, 5)}...`
                              : allgame.Created_by?.Name}
                          </h6>

                          <small>ID #{allgame?._id?.slice(-5)}</small>
                        </div>
                      </div>

                      <div className="neon-amount-box">
                        <span>{translations[language].entry}</span>
                        <h6>₹{allgame?.Game_Ammount}</h6>
                      </div>

                    </div>

                    {/* Center */}
                    <div className="neon-middle">

                      <span>{translations[language].prize}</span>

                      <h5>
                        ₹
                        {allgame?.Game_Ammount +
                          winnAmount(allgame?.Game_Ammount)}
                      </h5>

                    </div>

                    {/* Right */}
                    <div className="neon-right">

                      {userId !== allgame?.Created_by?._id &&
                        allgame?.Status === "new" && (
                          <button
                            className="action-neon play"
                            onClick={() => {
                              disable_play_btn();
                              AcceptChallang(allgame?._id);
                            }}
                          >
                            PLAY
                          </button>
                        )}

                      {userId === allgame?.Created_by?._id &&
                        allgame?.Status === "new" && (
                          <button
                            className="action-neon delete"
                            onClick={() => deleteChallenge(allgame?._id)}
                          >
                            <MdOutlineDelete size={20} />
                          </button>
                        )}

                      {userId === allgame?.Created_by?._id &&
                        allgame?.Status === "requested" && (
                          <div className="action-group">
                            <button
                              className="action-neon start"
                              onClick={() => {
                                disablebtn(allgame?._id);
                                req_chall_fun(allgame?._id);
                              }}
                            >
                              START
                            </button>

                            <button
                              className="action-neon cancel"
                              onClick={() => RejectGame(allgame?._id)}
                            >
                              ✕
                            </button>
                          </div>
                        )}

                    </div>

                  </div>
                ))}
            </div>
            <div className="battle_divider"></div>
            <div className="mb-5">
              <div className="battle-cards">
                <span
                  className={`battle-lefts`}
                >
                <img
                  src={
                    process.env.PUBLIC_URL + "/images/Battle soft colour.gif"
                  }
                  alt=""
                  width="30px"
                /></span>
                <span
                  className={`mx-2 ${css.gamesSectionTitle} battle-titles`}
                >
                  {translations[language].running}
                </span>
                <div class="battle-arrow">
                      ➜
                  </div>
                
              </div>

              {MyrunningBattle &&
                MyrunningBattle.map((runnig) => {
                  if (
                    ((userId == runnig.Accepetd_By._id
                      ? (runnig.Status === "running" &&
                          userId == runnig.Accepetd_By._id &&
                          runnig.Acceptor_seen == true) ||
                        runnig.Status === "pending"
                      : (runnig.Status === "running" &&
                          userId == runnig.Created_by._id) ||
                        runnig.Status === "pending") ||
                      runnig.Status == "conflict") &&
                    (runnig.Game_type == game_type ||
                      runnig.Game_type == "ludoClassicManual" ||
                      runnig.Game_type == "ludoClassicRich" ||
                      runnig.Game_type == "LudoPopular")
                  )
                    return (
                      <RunningCard
                        key={runnig._id}
                        runnig={runnig}
                        user={users}
                        winnAmount={winnAmount}
                      />
                    );
                })}

              {OtherrunningBattle &&
                OtherrunningBattle.map((runnig) => {
                  if (
                    (userId == runnig?.Accepetd_By?._id ||
                    userId == runnig?.Created_by?._id
                      ? userId == runnig.Accepetd_By._id
                        ? (runnig.Status === "running" &&
                            userId == runnig.Accepetd_By._id &&
                            runnig.Acceptor_seen == true) ||
                          (runnig.Status === "pending" &&
                            runnig.Acceptor_status == null)
                        : (runnig.Status === "running" &&
                            user == runnig.Created_by._id) ||
                          (runnig.Status === "pending" &&
                            runnig.Creator_Status == null)
                      : runnig.Status === "running" ||
                        runnig.Status === "pending") &&
                    (runnig.Game_type == game_type ||
                      game_type == "ludoClassicManual" ||
                      game_type == "ludoClassicRich")
                  )
                    return (
                      <>
                        <RunningCard
                          key={runnig._id}
                          runnig={runnig}
                          user={users}
                          winnAmount={winnAmount}
                        />
                      </>
                    );
                })}
              {/* --------------------- bots -------------  */}

              {runningsGames &&
                runningsGames.map((runnig) => {
                  if (
                    (userId == runnig?.Accepetd_By?._id ||
                    userId == runnig?.Created_by?._id
                      ? userId == runnig.Accepetd_By._id
                        ? (runnig.Status === "running" &&
                            userId == runnig.Accepetd_By._id &&
                            runnig.Acceptor_seen == true) ||
                          (runnig.Status === "pending" &&
                            runnig.Acceptor_status == null)
                        : (runnig.Status === "running" &&
                            user == runnig.Created_by._id) ||
                          (runnig.Status === "pending" &&
                            runnig.Creator_Status == null)
                      : runnig.Status === "running" ||
                        runnig.Status === "pending") &&
                    (runnig.Game_type == game_type ||
                      game_type == "ludoClassicManual" ||
                      game_type == "ludoClassicRich")
                  )
                    return (
                      <>
                        <RunningCard
                          key={runnig._id}
                          runnig={runnig}
                          user={users}
                          winnAmount={winnAmount}
                        />
                      </>
                    );
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}
